<app-replay-controller *ngIf="asOfDateMode"></app-replay-controller>
<div *ngIf="compareMode && !asOfDateMode">
    <app-reference-time-controller></app-reference-time-controller>
</div>
<div #ladderPanel class="data-table-panel">
    <p-table [hidden]="showChart" [value]="tableData" [selectionMode]="getSelectionMode()" [(selection)]="selectedRow" (onRowSelect)="onRowSelect($event)"
        [rowTrackBy]="rowTrackBy" styleClass="p-datatable-striped" class="liquitics-compact-table">
        <ng-template pTemplate="header">
            <tr>
                <th rowspan="2" class="sh-bucket-header">Bucket</th>
                <th *ngFor="let block of blocks; let i = index" [attr.colspan]="amountCols.length" [class]="'ccy'+i">
                    <div fxLayout="row">
                        <span fxFlex="1 0 auto"></span>
                        <span fxFlex="0 0 auto">{{getColumnHeader(block, i)}}</span>
                        <span fxFlex="0 0 auto" [class]="flagIconClass(block)"></span>
                        <!-- <mat-menu #historyMetricTypeMenu="mdMenu" xPosition="before" [overlapTrigger]="false">
                        <div *ngFor="let metric of ['Cumulative','Buffer','Surplus']">
                            <button mat-menu-item (click)="onHistory(block, metric)">
                                <span>{{metric}}</span>
                            </button>
                        </div>
                    </mat-menu>
                    <span fxFlex="1 0 auto" class="fa fa-clock-o jump-to-history" [mdMenuTriggerFor]="historyMetricTypeMenu"></span> -->
                        <span fxFlex="1 0 auto" class="fa fa-clock-o jump-to-history" (click)="onHistory(block, 'Cumulative')"></span>
                    </div>
                </th>
            </tr>
            <tr>
                <ng-container  *ngFor="let block of blocks" >
                    <th *ngFor="let amountCol of amountCols">
                        <!-- <ng-template pTemplate="header"> -->
                            <span class="sh-regular-header">{{ amountCol.header }}</span>
                            <span class="sh-compact-header">{{ amountCol.header | slice:0:1}}</span>
                        <!-- </ng-template> -->
                    </th>
                </ng-container>
            </tr>
        </ng-template>


        <!--scrollable="true" scrollHeight="72vh" // This causes bucket to shift for some reason...-->
        <!-- <p-headerColumnGroup>
            <p-row>
                <p-column header="Bucket" rowspan="2" [style]="{'width':'4em'}"></p-column>
                <p-column *ngFor="let block of blocks; let i = index" [header]="block" [colspan]="amountCols.length" [class]="'ccy'+i">
                    <ng-template pTemplate="header">
                        <div fxLayout="row">
                            <span fxFlex="1 0 auto"></span>
                            <span fxFlex="0 0 auto">{{getColumnHeader(block, i)}}</span>
                            <span fxFlex="0 0 auto" [class]="flagIconClass(block)"></span> -->
 <!-- Precommented before refactor to turbotable start-->
                            <!-- <mat-menu #historyMetricTypeMenu="mdMenu" xPosition="before" [overlapTrigger]="false">
                            <div *ngFor="let metric of ['Cumulative','Buffer','Surplus']">
                                <button mat-menu-item (click)="onHistory(block, metric)">
                                    <span>{{metric}}</span>
                                </button>
                            </div>
                        </mat-menu>
                        <span fxFlex="1 0 auto" class="fa fa-clock-o jump-to-history" [mdMenuTriggerFor]="historyMetricTypeMenu"></span> -->
<!-- Precommented before refactor to turbotable end-->
                            <!-- <span fxFlex="1 0 auto" class="fa fa-clock-o jump-to-history" (click)="onHistory(block, 'Cumulative')"></span>
                        </div>
                    </ng-template>
                </p-column>
            </p-row>
            <p-row>
                <div *ngFor="let block of blocks">
                    <p-column *ngFor="let amountCol of amountCols" [header]="amountCol.header">
                        <ng-template pTemplate="header">
                            <span class="sh-regular-header">{{ amountCol.header }}</span>
                            <span class="sh-compact-header">{{ amountCol.header | slice:0:1}}</span>
                        </ng-template>
                    </p-column>
                </div>
            </p-row>
        </p-headerColumnGroup> -->
        <ng-template pTemplate="body" let-entry let-odd="odd">
            <tr [pSelectableRow]="entry">
                <td>
                    <span [appTDCell]="[[getBucketClass(entry)],[]]">{{entry.bucket}}</span>
                </td>
                <ng-container *ngFor="let block of blocks; let blkIndex = index">
                    <td *ngFor="let col of amountCols; let amountIndex = index">
                        <span [appTDCell]="[['folder-row', 'amount_'+amountIndex],[]]" *ngIf="entry[block+'_'+col.field] !== undefined"></span>
                        <span [appTDCell]="tdPositiveCellValue(blkIndex, amountIndex, entry[block+'_'+col.field], block+'_'+col.field, entry)" *ngIf="isPositive(entry[block+'_'+col.field])"
                              [class]="'cell-amount-positive'+blkIndex">
                            {{round(entry[block+'_'+col.field]) }}
                        </span>
                        <span [appTDCell]="tdNegativeCellValue(blkIndex, amountIndex, entry[block+'_'+col.field], block+'_'+col.field, entry)" *ngIf="isNegative(entry[block+'_'+col.field])"
                              [class]="'cell-amount-negative'+blkIndex">
                           {{round(entry[block+'_'+col.field]) }}
                        </span>
                        <span [appTDCell]="tdZeroCellValue(blkIndex, amountIndex, entry[block+'_'+col.field], block+'_'+col.field, entry)" *ngIf="isZero(entry[block+'_'+col.field])"
                              [class]="'cell-amount-zero'+blkIndex">
                           {{round(entry[block+'_'+col.field]) }}
                        </span>
                    </td>
                    <!-- <td *ngFor="let col of amountCols; let amountIndex = index" >
                        <span [appTDCell]="[['folder-row', 'amount_'+amountIndex],[]]" *ngIf="entry[block+'_'+col.field]"></span>
                        <span [appTDCell]="tdPositiveCellValue(blkIndex, amountIndex, entry[block+'_'+col.field], col.field, entry)" *ngIf="isPositive(entry[block+'_'+col.field])"
                            [class]="'cell-amount-positive'+blkIndex">{{round(entry[block+'_'+col.field]) }}
                        </span>
                        <span [appTDCell]="tdNegativeCellValue(blkIndex, amountIndex, entry[block+'_'+col.field], col.field, entry)" *ngIf="isNegative(entry[block+'_'+col.field])"
                            [class]="'cell-amount-negative'+blkIndex">{{round(entry[block+'_'+col.field]) }}
                        </span>
                        <span [appTDCell]="tdZeroCellValue(blkIndex, amountIndex, entry[block+'_'+col.field], col.field, entry)" *ngIf="isZero(entry[block+'_'+col.field])"
                            [class]="'cell-amount-zero'+blkIndex">{{round(entry[block+'_'+col.field]) }}
                        </span>
                    </td> -->
                </ng-container>
            </tr>
        </ng-template>

        <!-- <p-column [field]="'bucket'" header="Bucket" frozen="true" [style]="{'width':'4em'}">
            <ng-template let-row let-col let-entry="rowData" pTemplate="body">
                <span [appTDCell]="[[getBucketClass(entry)],[]]">{{entry[col.field]}}</span>
            </ng-template>
        </p-column>
        <div *ngFor="let block of blocks; let blkIndex = index">
            <p-column *ngFor="let col of amountCols; let amountIndex = index" [field]="block+'_'+col.field" [header]="col.header">
                <ng-template let-row let-col let-entry="rowData" let-odd="odd" pTemplate="body">
                    <span [appTDCell]="[['folder-row', 'amount_'+amountIndex],[]]" *ngIf="entry['folderRow']"></span>
                    <span [appTDCell]="tdPositiveCellValue(blkIndex, amountIndex, entry[col.field], col.field, entry)" *ngIf="isPositive(entry[col.field])"
                        [class]="'cell-amount-positive'+blkIndex">{{round(entry[col.field]) }}
                    </span>
                    <span [appTDCell]="tdNegativeCellValue(blkIndex, amountIndex, entry[col.field], col.field, entry)" *ngIf="isNegative(entry[col.field])"
                        [class]="'cell-amount-negative'+blkIndex">{{round(entry[col.field]) }}
                    </span>
                    <span [appTDCell]="tdZeroCellValue(blkIndex, amountIndex, entry[col.field], col.field, entry)" *ngIf="isZero(entry[col.field])"
                        [class]="'cell-amount-zero'+blkIndex">{{round(entry[col.field]) }}
                    </span>
                </ng-template>
            </p-column>
        </div> -->
    </p-table>
    <div *ngIf="compareMode && (panelBlocked)" class="loading-overlay">
        <i class="fa fa-spin fa-circle-o-notch fa-5x" style="position:absolute;top:50%;left:50%"></i>
    </div>
</div>
<div [hidden]="!showChart">
    <div fxLayout="column">
        <div *ngFor="let block of chartBlocks" fxFlex="1 1 100%">
            <div class="liquitics-h1 ladderHeader">{{block | uppercase}}</div>
            <div class="ladderChart p-panel-content-wrapper" [id]="chartDivName()+block" [style.height]="chartHeight()"></div>
        </div>
    </div>
</div>